'use es6';

import styled from 'styled-components';
import UISelect from 'UIComponents/input/UISelect';
import UIButton from 'UIComponents/button/UIButton';
import { OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
const TERTIARY_LIGHT_TEXT = '#506e91';
export const FontStyledUITextToolbarSelect = styled(UISelect).withConfig({
  displayName: "StyledComponents__FontStyledUITextToolbarSelect",
  componentId: "ha8hq1-0"
})(["min-width:130px;padding:5px 6px !important;font-size:12px !important;background-color:", " !important;color:", " !important;height:32px !important;span{border-top-color:", ";}"], OLAF, TERTIARY_LIGHT_TEXT, TERTIARY_LIGHT_TEXT);
export const FontVariantOption = styled.span.withConfig({
  displayName: "StyledComponents__FontVariantOption",
  componentId: "ha8hq1-1"
})(["min-height:30px;padding:12px 20px;font-size:13px;"]);
export const FontVariantButton = styled(UIButton).withConfig({
  displayName: "StyledComponents__FontVariantButton",
  componentId: "ha8hq1-2"
})(["text-decoration:none;margin:0 !important;min-height:30px !important;margin-bottom:1px !important;padding:12px 20px !important;&&:hover{text-decoration:none;}"]);
export const FontVariantSelect = styled(UISelect).withConfig({
  displayName: "StyledComponents__FontVariantSelect",
  componentId: "ha8hq1-3"
})(["background:transparent !important;border:none !important;font-size:13px !important;color:", " !important;height:auto !important;padding:3px 6px !important;font-weight:500 !important;&&:hover{color:", ";text-decoration:none;background:transparent;}&&:focus{background:transparent;box-shadow:none;}.uiDropdown__buttonCaret{transform:rotate(-90deg);border-top-color:", ";}"], OBSIDIAN, OBSIDIAN, OBSIDIAN);